import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import { Filter, X } from "lucide-react";
import { DateRangeInputs } from "@libs/rubick";
import { INVOICE_FILTER_ALL, INVOICE_STATUSES, INVOICE_STATUS_LABELS } from "@/constants/invoices";
import { Select } from "@/components/ui/Select";
import { formatDateInput, parseDateInput } from "@/utils/date";
export default function InvoiceFilters({ filters, onFiltersChange }) {
    const [localFilters, setLocalFilters] = useState(filters);
    const handleStatusChange = (status)=>{
        const newStatus = status === INVOICE_FILTER_ALL ? undefined : status;
        const newFilters = {
            ...localFilters,
            status: newStatus
        };
        setLocalFilters(newFilters);
        onFiltersChange(newFilters);
    };
    const handleStartDateChange = (date)=>{
        const startDate = date ? formatDateInput(date) : undefined;
        const newFilters = {
            ...localFilters,
            startDate
        };
        setLocalFilters(newFilters);
        onFiltersChange(newFilters);
    };
    const handleEndDateChange = (date)=>{
        const endDate = date ? formatDateInput(date) : undefined;
        const newFilters = {
            ...localFilters,
            endDate
        };
        setLocalFilters(newFilters);
        onFiltersChange(newFilters);
    };
    const clearFilters = ()=>{
        const emptyFilters = {};
        setLocalFilters(emptyFilters);
        onFiltersChange(emptyFilters);
    };
    const hasActiveFilters = localFilters.status || localFilters.startDate || localFilters.endDate;
    return /*#__PURE__*/ _jsxs("div", {
        className: "bg-white shadow rounded-lg p-4",
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "flex items-center justify-between mb-4",
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "flex items-center space-x-2",
                        children: [
                            /*#__PURE__*/ _jsx(Filter, {
                                className: "h-5 w-5 text-gray-400"
                            }),
                            /*#__PURE__*/ _jsx("h3", {
                                className: "text-lg font-medium text-gray-900",
                                children: "Filters"
                            })
                        ]
                    }),
                    hasActiveFilters && /*#__PURE__*/ _jsxs("button", {
                        onClick: clearFilters,
                        className: "flex items-center space-x-1 text-sm text-gray-500 hover:text-gray-700",
                        children: [
                            /*#__PURE__*/ _jsx(X, {
                                className: "h-4 w-4"
                            }),
                            /*#__PURE__*/ _jsx("span", {
                                children: "Clear All"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "grid grid-cols-1 sm:grid-cols-3 gap-4",
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "relative",
                        children: [
                            /*#__PURE__*/ _jsx("label", {
                                htmlFor: "status",
                                className: "block text-sm font-medium text-gray-700 mb-2",
                                children: "Status"
                            }),
                            /*#__PURE__*/ _jsxs(Select, {
                                id: "status",
                                value: localFilters.status || INVOICE_FILTER_ALL,
                                onChange: (e)=>handleStatusChange(e.target.value),
                                children: [
                                    /*#__PURE__*/ _jsx("option", {
                                        value: INVOICE_FILTER_ALL,
                                        className: "py-2",
                                        children: "All Statuses"
                                    }),
                                    /*#__PURE__*/ _jsx("option", {
                                        value: INVOICE_STATUSES.PENDING,
                                        className: "py-2",
                                        children: INVOICE_STATUS_LABELS[INVOICE_STATUSES.PENDING]
                                    }),
                                    /*#__PURE__*/ _jsx("option", {
                                        value: INVOICE_STATUSES.PAID,
                                        className: "py-2",
                                        children: INVOICE_STATUS_LABELS[INVOICE_STATUSES.PAID]
                                    }),
                                    /*#__PURE__*/ _jsx("option", {
                                        value: INVOICE_STATUSES.OVERDUE,
                                        className: "py-2",
                                        children: INVOICE_STATUS_LABELS[INVOICE_STATUSES.OVERDUE]
                                    }),
                                    /*#__PURE__*/ _jsx("option", {
                                        value: INVOICE_STATUSES.CANCELLED,
                                        className: "py-2",
                                        children: INVOICE_STATUS_LABELS[INVOICE_STATUSES.CANCELLED]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "sm:col-span-2",
                        children: [
                            /*#__PURE__*/ _jsx("label", {
                                className: "block text-sm font-medium text-gray-700 mb-2",
                                children: "Date Range"
                            }),
                            /*#__PURE__*/ _jsx(DateRangeInputs, {
                                startDate: parseDateInput(localFilters.startDate),
                                endDate: parseDateInput(localFilters.endDate),
                                onStartDateChange: handleStartDateChange,
                                onEndDateChange: handleEndDateChange,
                                startPlaceholder: "From date",
                                endPlaceholder: "To date"
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
